import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';

export const YAxis = styled.g`
    fill: none;
`;
export const YAxisLabel = styled.text`
    font-size: 14px;
    fill: ${Variables.Colors.n50};
    letter-spacing: 0.5px;
`;

export const YAxisLine = styled.line`
    opacity: 0.32;
    stroke: ${Variables.Colors.p100};
    stroke-width: 0.5px;
    stroke-dasharray: 2px 2px;
    shape-rendering: crispedges;

    &:first-of-type {
        stroke-dasharray: 0;
    }
`;
